'use client';

import { Trans, useTranslation } from 'react-i18next';
import { COMPANY_COUNTRIES, type CompanyCountryCode } from '@/lib/countries';
import { SwissDataSourceNote } from './SwissDataSourceNote';

/**
 * Page-level origin and modification notice for register data whose reuse
 * terms require one. CH renders the Swiss note unchanged; AT credits the
 * Firmenbuch under CC BY 4.0 (credit "Österreichisches Firmenbuch / BMJ –
 * Justiz", licence link, and that FirmenData processed and enriched it).
 * German register data carries no such condition, so DE renders nothing.
 */
export function RegisterSourceNote({
  country,
  locationAttribution,
}: {
  country: CompanyCountryCode;
  /** The geocoding source's required credit (BEV Adressregister for AT). */
  locationAttribution?: string | null;
}) {
  const { t } = useTranslation();
  if (country === 'DE') return null;
  if (country === 'CH') return <SwissDataSourceNote />;
  return (
    <div className="mt-6 space-y-1 text-xs text-muted-foreground">
      <p>
        <Trans
          i18nKey="companyDetail.austrianSource.attribution"
          components={{
            registry: (
              <a
                href={COMPANY_COUNTRIES.AT.sourceOrganization.url}
                className="underline"
              />
            ),
            license: (
              <a
                href="https://creativecommons.org/licenses/by/4.0/"
                className="underline"
              />
            ),
          }}
        />
      </p>
      <p>{t('companyDetail.austrianSource.modified')}</p>
      {locationAttribution && <p>{locationAttribution}</p>}
    </div>
  );
}
